'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dateToTZ = undefined;

var _dateUtils = require('../../common/utils/date-utils');

var dateToTZ = exports.dateToTZ = function dateToTZ() {
  return function (input, feisTZ) {
    if (input) return (0, _dateUtils.convertMsToDate)(input, feisTZ);
  };
};


//////////////////
// WEBPACK FOOTER
// ./common/filters/dateToTZ.js
// module id = 476
// module chunks = 0